import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'sbw-popup-demo',
    templateUrl: './popup-demo.component.html'
})
export class PopupDemoComponent implements OnInit {
    public showCancelablePopup = false;
    public showNonCancelablePopup = false;

    public openNonCancelablePopup() {
        this.showNonCancelablePopup = true;
    }

    public confirmNonCancelablePopup() {
        this.showNonCancelablePopup = false;
    }
    constructor() { }

    ngOnInit() {
    }

    public openCancelablePopup() {
        this.showCancelablePopup = true;
    }

    public cancelPopup() {
        this.showCancelablePopup = false;
    }
}
